
export default function Blogs()
{
    return <>
        <div>BLOGS</div>
    </>
}